import { populatePlanningStream, populateEnrolledCourses, getCourseDetail, askSuggestForLast, getClassSummaryWithPeer, getCompetencySummary, getCourseTopics, getLearningTopicDetails, getLearningContentDetails, getEntityActivity, getEntityCompetencySummary, askSuggestForNext, getInstitutionDetails, getInstitutionPackages, getCareerDetail, populateCareerByCodeAndSource, getCourseCompetencies, getBlackboardCourseAccess, getBlackboardContentAccess, getBlackboardAnnouncements,
getBlackboardGradeActivity, getBlackboardAggregatedGradeActivity, getLibrariesForUser, getUserAdvisor, getAllCalendarEvents,
getInstitutionMetaInfo, getQuestionsForGroup, saveUserProfileAndAnswer, getLearnerDashboardState, getNextCalendarEvent,getFeedsForStudent,
getRecommendationsForStudent, getNotificationsForStudent, getAllChannels, getCoursesWithChannel, getCourseSectionChannel,
uploadFileAttachment, createChannel, getDirectChannelUsers, getDirectChannelPeerMap, addToDirectChannelPeerMap,
updateDirectChannelPeerMap, createStudyGroup, deleteStudyGroup, getParticipantDisplayNames, getAllBadWords,
getMicroCompetencySummary, populateStreamWithStructure, getLearnerEnrollmentData, getUserSubscriptions,
getUserPaymentMethods, putCreateUserPaymentMethod, putCreateUserSubscription, putCancelUserSubscription,
getInstitutionProducts, getUserTransactions, getInstitutionMetaInfoForSelfRegistration, getAllUserAccounts, getCurrentEnvironment,
updateUserProfileResume, updateUserProfileResumeAsPrimary, deleteUserProfileResume,getStreamLeafForCourse,
getCheckTransactionValidity, populateProgramTracking,  populateQuickLinks, getLearnerEnrollmentDataForCode, getAllPurchasePrograms, getCompetencyLogic, populateAttemptAIReport, getAIContents, logDashboardActivity,populateStreamWithStructureSummary } from '../api'

import { setItem, getItem } from '../../../storage'

export const loadCurrentEnvironment = ({ state, commit }) => {
  return getCurrentEnvironment().then(environment => {
    commit('LOAD_CURRENT_ENVIRONMENT', environment)
    return environment
  })
}

export const loadInstitutionDetail = ({ state, commit }, uuid) => {
  return getInstitutionDetails(uuid).then(data => {
    commit('LOAD_INSTITUTION', data)
    return data
  })
}
export const loadInstitutionPackage = ({ state, commit }, {uuid, isAggregated}) => {
  return getInstitutionPackages(uuid, isAggregated).then(packageList => {
    if (packageList !== undefined) {
      commit('LOAD_PACKAGES', packageList)
      let enabledFeatures = {}
      packageList.forEach(packageObj => {
        let features = packageObj.features || []
        features.forEach((feature) => {
          enabledFeatures[feature.featureId] = feature
        })
      })
      commit('LOAD_ENABLED_FEATURES', enabledFeatures)
    }
    return packageList
  })
}

export const loadPlanningStream = ({ state, commit }) => {
  return populatePlanningStream().then(data => {
    if (data !== undefined) {
      commit('LOAD_PLANNING_STREAM', data)
    }
    return data
  })
}

export const loadEnrolledCourses = ({ state, commit }, pagingOptions) => {
  return populateEnrolledCourses(pagingOptions)
}

export const loadCourseDetail = ({ state, commit }, uuid) => {
  return getCourseDetail(uuid).then((res) => {
    commit('LOAD_COURSE', res)
    return res
  })
}
export const loadAIContents = ({ state, commit }, courseId) => {
  return getAIContents(courseId).then((data) => {
    return data
  })
}
export const loadCompetencyLogic = ({ state, commit }, { courseId, type }) => {
  return getCompetencyLogic(courseId, type).then((data) => {
    return data
  })
}
export const loadAIResource = ({ state, commit }, { entityType, entityUuid }) => {
    return getLearningContentDetails(entityUuid).then((res) => {
      return res
    })
}
export const loadContinueLearningLast = ({ state, commit }, uuid) => {
  return askSuggestForLast(uuid).then((res) => {
    return res
  })
}

export const loadClassSummaryWithPeer = ({ state, commit }, entityId) => {
  return getClassSummaryWithPeer(entityId).then((res) => {
    return res
  })
}
export const loadStreamLeafForCourse = ({ state, commit }, {programCode, originUuid}) => {
  return getStreamLeafForCourse(programCode, originUuid).then(data => {
    return data
  })
}
export const loadCompetencyProgress = ({ state, commit }, entityId) => {
  return getCompetencySummary(entityId).then((res) => {
    if (res && res.length > 0) {
      for (var i = 0; i < res.length; i++) {
        var competency = res[i]
        if (competency && (competency.entityId === entityId)) {
          return competency
        }
      }
    }
  })
}
export const loadCompetencyProgressForCourseAndUser = ({ state, commit }, entityId) => {
  return getCompetencySummary(entityId).then((res) => {
    if (res && res.length > 0) {
      for (var i = 0; i < res.length; i++) {
        var competency = res[i]
        if (competency && (competency.entityId === entityId)) {
          return competency
        }
      }
    }
  })
}


export const loadMicroCompetencyProgress = ({ state, commit }, entityId) => {
  return getMicroCompetencySummary(entityId)
}

export const loadCourseTopics = ({ state, commit }, { uuid, loadDataFromServer }) => {
  var stateTopics = state.topics
  var stateLinearTopics = state.linearTopics
  var stateTopicsMap = state.topicsMap
  if (loadDataFromServer || stateTopics.length === 0 || stateLinearTopics.length === 0) {
    return getCourseTopics(uuid).then((res) => {
      var topics = JSON.parse(res.plan)
      var linearTopics = []
      var topicsMap = {}
      for (var i = 0; i < topics.length; i++) {
        linearTopics = linearTopics.concat(topics[i])
        if (topics[i].plan) {
          topics[i].subtopics = JSON.parse(topics[i].plan)
          for (var j = 0; j < topics[i].subtopics.length; j++) {
            linearTopics = linearTopics.concat(topics[i].subtopics[j])
            if (topics[i].subtopics[j].plan) {
              topics[i].subtopics[j].subtopics = JSON.parse(topics[i].subtopics[j].plan)
              linearTopics = linearTopics.concat(topics[i].subtopics[j].subtopics)
            }
          }
        }
      }
      commit('LOAD_COURSE_TOPICS', {isState: false, data: topics})
      commit('LOAD_COURSE_LINEAR_TOPICS', {isState: false, data: linearTopics})

      linearTopics.forEach((item, i) => {
        topicsMap[item.uuid] = item
      })
      commit('LOAD_COURSE_TOPICS_MAP', {isState: false, data: topicsMap})
      return topics
    })
  } else {
    commit('LOAD_COURSE_TOPICS', {isState: true, data: stateTopics})
    commit('LOAD_COURSE_LINEAR_TOPICS', {isState: true, data: stateLinearTopics})
    commit('LOAD_COURSE_TOPICS_MAP', {isState: true, data: stateTopicsMap})
    return stateTopics
  }
}
export const loadCourseLinearTopics = ({ state, commit }, { uuid, loadDataFromServer }) => {
  var stateTopics = state.topics
  var stateLinearTopics = state.linearTopics
  var stateTopicsMap = state.topicsMap
  if (loadDataFromServer || stateTopics.length === 0 || stateLinearTopics.length === 0) {
    return getCourseTopics(uuid).then((res) => {
      var topics = JSON.parse(res.plan)
      var linearTopics = []
      var topicsMap = {}
      for (var i = 0; i < topics.length; i++) {
        linearTopics = linearTopics.concat(topics[i])
        if (topics[i].plan) {
          topics[i].subtopics = JSON.parse(topics[i].plan)
          for (var j = 0; j < topics[i].subtopics.length; j++) {
            linearTopics = linearTopics.concat(topics[i].subtopics[j])
            if (topics[i].subtopics[j].plan) {
              topics[i].subtopics[j].subtopics = JSON.parse(topics[i].subtopics[j].plan)
              linearTopics = linearTopics.concat(topics[i].subtopics[j].subtopics)
            }
          }
        }
      }
      commit('LOAD_COURSE_TOPICS', {isState: false, data: topics})
      commit('LOAD_COURSE_LINEAR_TOPICS', {isState: false, data: linearTopics})

      linearTopics.forEach((item, i) => {
        topicsMap[item.uuid] = item
      })
      commit('LOAD_COURSE_TOPICS_MAP', {isState: false, data: topicsMap})
      return linearTopics
    })
  } else {
    commit('LOAD_COURSE_TOPICS', {isState: true, data: stateTopics})
    commit('LOAD_COURSE_LINEAR_TOPICS', {isState: true, data: stateLinearTopics})
    commit('LOAD_COURSE_TOPICS_MAP', {isState: true, data: stateTopicsMap})
    return stateTopics
  }
}
export const loadCourseCompetencies = ({ state, commit }, { courseId, loadDataFromServer }) => {
  if (loadDataFromServer || (state.competencies.length === 0)) {
    return getCourseCompetencies(courseId).then((res) => {
      commit('LOAD_COURSE_COMPETENCIES', res)
      return res
    })
  } else {
    commit('LOAD_COURSE_COMPETENCIES', state.competencies)
    return state.competencies
  }
}
export const loadTopicDetail = ({ state, commit }, topicId ) => {
    return getLearningTopicDetails(topicId).then((res) => {
        return res
    })
}
export const loadEntityDetail = ({ state, commit }, { entityType, entityUuid }) => {
  if (entityType === 'LearningTopic') {
    return getLearningTopicDetails(entityUuid).then((res) => {
      commit('LOAD_ENTITY_DETAIL', res)
      commit('LOAD_ENTITY_UUID', entityUuid)
    })
  } else {
    return getLearningContentDetails(entityUuid).then((res) => {
      commit('LOAD_ENTITY_DETAIL', res)
      commit('LOAD_ENTITY_UUID', entityUuid)
      return res
    })
  }
}


export const showAttemptAIReport = ({ state, commit }, { activityId, sessionId, courseId, userId }) => {
  return populateAttemptAIReport(activityId, sessionId, courseId, userId)
}
export const loadEntityActivity = ({ state, commit }, { courseUuid, entityType, entityUuid }) => {
  return getEntityActivity(courseUuid, entityUuid).then((res) => {
    return res
  })
}

export const loadEntityCompetency = ({ state, commit }, { courseId, entityId }) => {
  return getEntityCompetencySummary(courseId, entityId).then((res) => {
    commit('LOAD_ENTITY_COMPETENCY', res)
  })
}

export const loadNextEntityDetail = ({ state, commit }, { courseUuid, entityType, entityUuid }) => {
  return askSuggestForNext(courseUuid, entityUuid).then((res) => {
    commit('LOAD_NEXT_ENTITY_DETAIL', res)
    commit('LOAD_ENTITY_UUID', res.uuid)
    return res
  })
}

export const loadCareeDetail = ({ state, commit }, name) => {
  return getCareerDetail(name)
}

export const loadCareerOneStopInfo = ({ state, commit }, code) => {
  let careerOneStopCode = code.split('.')[0] + '.00'
  let source = 'COS'
  return populateCareerByCodeAndSource(careerOneStopCode, source)
}

export const loadBlackboardCourseAccess = ({ state, commit }, lmsCourseId) => {
  return getBlackboardCourseAccess(lmsCourseId).then((res) => {
    return res
  })
}

export const loadBlackboardContentAccess = ({ state, commit }, lmsCourseId) => {
  return getBlackboardContentAccess(lmsCourseId).then((res) => {
    return res
  })
}

export const loadBlackboardGradeActivity = ({ state, commit }, lmsCourseId) => {
  return getBlackboardGradeActivity(lmsCourseId).then((res) => {
    return res
  })
}

export const loadBlackboardAggregatedGradeActivity = ({ state, commit }, lmsCourseId) => {
  return getBlackboardAggregatedGradeActivity(lmsCourseId).then((res) => {
    return res.aggregatedGradeActivities
  })
}

export const loadBlackboardAnnouncements = ({ state, commit }, lmsCourseId) => {
  return getBlackboardAnnouncements(lmsCourseId).then((res) => {
    return res
  })
}

export const loadLibrariesForUser = ({ state, commit }, {userId, userObject}) => {
  return getLibrariesForUser(userId).then(learningSpaces => {
    let folders = []
    let libraries = userObject.userPreferences ? userObject.userPreferences.learningSpaces : []
    $.each(learningSpaces, (index, learningSpace) => {
      for (var i = 0; i < libraries.length; i++) {
        if (libraries[i] === learningSpace.uuid) {
          folders.push(learningSpace)
          break
        }
      }
    })
    // commit('LOAD_LEARNING_SPACES', folders)
    return folders
  })
}

export const loadUserAdvisor = ({ state, commit }, uuid) => {
  return getUserAdvisor(uuid).then(res => {
    return res
  })
}

export const loadInstitutionMetaInfo = ({ state, commit }) => {
  return getInstitutionMetaInfo()
}

export const loadQuestionsForGroup = ({ state, commit }, group) => {
  return getQuestionsForGroup(group)
}

export const loadSaveUserProfileAndAnswer = ({ state, commit }, data) => {
  return saveUserProfileAndAnswer(data)
}

export const loadLearnerDashboardState = ({ state, commit }) => {
  return getLearnerDashboardState().then(data => {
    commit('LOAD_LEARNER_DASHBOARD_STATE', data)
    commit('LOAD_LEARNER_DASHBOARD_COMPONENTS', data.components)
    return data
  })
}

export const loadLearnerEnrollmentData = ({ state, commit }, userId) => {
  return getLearnerEnrollmentData(userId).then(data => {
    commit('LOAD_LEARNER_ENROLLMENT_DATA', data)
    return data
  })
}

export const loadLearnerEnrolledProgramForCode = ({ state, commit }, code) => {
  return getLearnerEnrollmentDataForCode(code).then(data => {
    return data
  })
}

export const loadGetNextCalendarEvent = ({ state, commit }) => {
  return getNextCalendarEvent()
}

export const loadFeedsForStudent= ({ state, commit }) => {
  return getFeedsForStudent()
}

export const loadRecommendationsForStudent = ({ state, commit }) => {
  return getRecommendationsForStudent()
}
export const loadQuickLinks = ({ state, commit }, type) => {
  return populateQuickLinks(type)
}
export const loadHandles = ({ state, commit }) => {
  return populateQuickLinks('SOCIALMEDIA')
}
export const loadNotificationsForStudent = ({ state, commit }) => {
  return getNotificationsForStudent()
}

export const loadAllCalendarEvents = ({ state, commit }) => {
  return getAllCalendarEvents()
}

export const loadAllChannels = ({ state, commit }) => {
  return getAllChannels().then(data => {
    commit('LOAD_ALL_CHANNELS', data)
    return data
  })
}

export const loadCoursesWithChannel = ({ state, commit }) => {
  return getCoursesWithChannel()
}

export const loadCourseSectionChannel = ({ state, commit }, courseSectionId) => {
  return getCourseSectionChannel(courseSectionId)
}

export const loadAttachmentUpload = ({ state, commit }, data) => {
  return uploadFileAttachment(data)
}

export const loadCreateChannel = ({ state, commit }, {channel}) => {
  return createChannel(channel)
}

export const loadDirectChannelUsers = ({ state, commit }, courseId) => {
  return getDirectChannelUsers(courseId)
}

export const loadDirectChannelPeerMap = ({ state, commit }) => {
  return getDirectChannelPeerMap()
}

export const loadAddToDirectChannelPeerMap = ({ state, commit }, selectedUsers) => {
  return addToDirectChannelPeerMap(selectedUsers)
}

export const loadUpdateDirectChannelPeerMap = ({ state, commit }, selectedUserId) => {
  return updateDirectChannelPeerMap(selectedUserId)
}

export const loadCreateStudyGroup = ({ state, commit }, {channelId, data}) => {
  return createStudyGroup(channelId, data)
}

export const loadDeleteStudyGroup = ({ state, commit }, {channelId, groupId}) => {
  return deleteStudyGroup(channelId, groupId)
}

export const loadParticipantDisplayNames = ({ state, commit }, uuids) => {
  return getParticipantDisplayNames(uuids)
}
export const loadProgramTracking = ({ state, commit }, programGuideCode) => {
    return populateProgramTracking(programGuideCode).then((response) => {
      return response
    })
}
export const loadAllBadWords = ({ state, commit }) => {
  return getAllBadWords().then(badWords => {
    let customBadWords = []
    badWords.forEach(badWord => {
      customBadWords.push(badWord.word)
    })
    commit('LOAD_CUSTOM_BAD_WORDS', customBadWords)
    return customBadWords
  })
}

export const updateUnread = ({ state, commit }, {channelId, unread}) => {
  commit('LOAD_CHANNEL_UNREAD_COUNT', {channelId, unread})
  return true
}

export const loadStreamWithStructure = ({ state, commit }, programCode) => {
  return populateStreamWithStructure(programCode)
}

export const loadStreamWithStructureSummary = ({ state, commit }, programCode) => {
  return populateStreamWithStructureSummary(programCode)
}

export const loadUserSubscriptions = ({ state, commit }) => {
  return getUserSubscriptions().then(res => {
    return res
  })
}

export const loadCreateUserSubscription = ({ state, commit }, userSubscriptionObj) => {
  return putCreateUserSubscription(userSubscriptionObj)
}
export const loadCancelUserSubscription = ({ state, commit }, subscriptionUuid) => {
  return putCancelUserSubscription(subscriptionUuid)
}

export const loadUserPaymentMethods = ({ state, commit }) => {
  return getUserPaymentMethods()
}

export const loadCreateUserPaymentMethod = ({ state, commit }, paymentMethodObj) => {
  return putCreateUserPaymentMethod(paymentMethodObj)
}

export const loadInstitutionProducts = ({ state, commit }) => {
  return getInstitutionProducts()
}

export const loadUserTransactions = ({ state, commit }) => {
  return getUserTransactions()
}

export const loadInstitutionMetaInfoForSelfRegistration = ({ state, commit }, uuid) => {
  return getInstitutionMetaInfoForSelfRegistration(uuid)
}

export const getAllUserAccountCount = ({ state, commit }) => {
  return getAllUserAccounts()
}

export const loadUpdateProfileResume = ({ state, commit }, {uuid, resume}) => {
  return updateUserProfileResume(uuid, resume)
}

export const loadUpdateProfileResumeAsPrimary = ({ state, commit }, {uuid, id}) => {
  return updateUserProfileResumeAsPrimary(uuid, id)
}

export const loadDeleteProfileResume = ({ state, commit }, {uuid, id}) => {
  return deleteUserProfileResume(uuid, id)
}

export const loadCheckTransactionValidity = ({ state, commit }, programId) => {
  return getCheckTransactionValidity(programId)
}

export const loadAllPurchasePrograms = ({ state, commit }) => {
  return getAllPurchasePrograms()
}
export const loadLogDashboardActivity = ({ state, commit }, {action, page, link, entityUuid, programCipCode, careerSocCode, programCode, preLoginInstitutionId, preLoginInstitutionName, preUser, stripeError}) => {
  let ua = window.navigator.userAgent
  let browserName = ''
  let browserVersion = ''
  try {
    var tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      browserName = 'IE'
      browserVersion= tem[1]
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
      if (tem != null && tem.length > 1) {
        browserName = tem[1].replace("OPR", "Opera")
        browserVersion= tem[2]
      } else {
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
        browserName = M[0]
        browserVersion = M[1]
      }
    } else {
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
      browserName = M[0]
      browserVersion = M[1]
    }
  } catch (e) {
    console.log('Couldnt compute browser information')
  }
  let uObj = (preUser?preUser:{})
  let role = 'Student'
  let institution = preLoginInstitutionName
  let institutionId = uObj.institutionId?uObj.institutionId:preLoginInstitutionId
  let token = ''
  let currentTime = (new Date()).getTime()
  let data = '&action=' + action +
             '&userUuid=' + uObj.uuid +
             '&userFirstName=' + uObj.firstName +
             '&userLastName=' + uObj.lastName +
             '&userEmail=' + uObj.eMail +
             '&userRole=' + role +
             '&institutionName=' + institution +
             '&institutionUuid=' + institutionId +
             '&studentType=' +
             '&advisor=' +
             '&major=' + uObj.major1Title +
             '&concentration=' + uObj.concentration1Title +
             '&minor=' + uObj.minor1Title +
             '&product=' +
             '&productPackage=' +
             '&productArea=' +
             '&page=' + page +
             '&link=' + link +
             '&MajorCIP=' +
             '&GPA=' + uObj.majorGpa +
             '&MajorGPA=' + uObj.overallGpa +
             '&entityUuid=' + entityUuid +
             '&programCipCode=' + programCipCode +
             '&programCode=' + programCode +
             '&careerSocCode=' + careerSocCode +
             '&recordedTime=' + currentTime +
             '&utm_medium=' + localStorage.getItem('utm_medium') +
             '&utm_source=' + localStorage.getItem('utm_source') +
             '&utm_campaign=' + localStorage.getItem('utm_campaign') +
             '&utm_content=' + localStorage.getItem('utm_content') +
             '&utm_term=' + localStorage.getItem('utm_term') +
             '&browser=' + browserName +
             '&browserVersion=' + browserVersion +
             '&userAgent=' + ua +
             '&stripeError' + stripeError

  return logDashboardActivity(data, token)
}



// WEBPACK FOOTER //
// ./src/app/dashboard/vuex/actions.js